import {NotificationService} from "@digicerba/common";
import {environment} from "@environments/environment";
import {
  AsiDialogService,
  AsiFileService,
  AsiTable,
  AsiTableData,
  AsiTableRequest,
  AsiTableSelectionModel
} from "@asi-ngtools/lib";
import {PlanifierAlerteModal} from "./../../planifier-alerte-modal/planifier-alerte.modal";
import {StatutDossierEnums} from "@common/enum/StatutDossier.enum";
import {HprimFaxDialog} from "@common/utils/dialog/dialog-hprim-fax.component";
import {
  HprimFaxDto,
  HprimFaxMedecin,
  IDossierWebServiceClient,
  ILaboratoireWebServiceClient,
  LigneDossierDto,
  RechercheDossierDto,
  RechercheDossierTriEnum,
  PaginationResultDto,
  StatutDossierEnum,
  ICorrespondantWebServiceClient, CorrespondantDto, FileProperties
} from "@resources/resources";
import {
  IInstanceModeleFormulaireWebServiceClient,
  RechercheInstanceModeleFormulaireDto,
} from "@resources/resources.external";
import {Component, Input, SimpleChange, ViewChild} from "@angular/core";
import {Router} from "@angular/router";
import * as lodash from "lodash";
import {TranslateService} from "@ngx-translate/core";
import {PopinCompleterDossierComponent} from "../../popin/popin-completer-dossier.component";
import {TagsDonneesManquantes} from "@common/constants/TagsDonneesManquantes";
import {DonneesManquantesComponent} from "@utils/dialog/dialog-donnees-manquantes/donnees-manquantes-component-dialog.component";
import {EtatEnums} from "@common/enum/Etat.enum";

@Component({
  selector: 'serveur-resultats-resultats',
  templateUrl: './serveur-resultats-resultats.component.html',
  host: {'class': 'page'}
})
export class ServeurResultatsResultatsComponent {

  @Input() rechercheDossierDto: RechercheDossierDto;
  @Input() hprimEnabled: Boolean;
  @Input() reemissionEnabled: Boolean;
  @ViewChild('dossierDataTable') articleTable: AsiTable<LigneDossierDto>;

  asiTableData: AsiTableData<LigneDossierDto> = new AsiTableData<LigneDossierDto>();
  searchHasTooManyResults: boolean;
  selectionModel = new AsiTableSelectionModel("id", false);
  currentSearchDto: RechercheDossierDto;
  tries: Array<{ code: RechercheDossierTriEnum, libelle: string }>;
  tri: RechercheDossierTriEnum;
  correspondants : CorrespondantDto[];
  fileProperties: FileProperties;
  showOverlay: boolean;
  showError: boolean;


  constructor(private dossierWebService: IDossierWebServiceClient,
              private router: Router,
              private asiDialogService: AsiDialogService,
              private laboratoireWebService: ILaboratoireWebServiceClient,
              private fileUtils: AsiFileService,
              private notificationService: NotificationService,
              private translateService: TranslateService,
              private instanceModeleFormulaireWebServiceClient: IInstanceModeleFormulaireWebServiceClient,
              private correspondantWebServiceClient: ICorrespondantWebServiceClient) {

    this.tries = new Array();
    this.tries.push({code: 'DATE_CREATION', libelle: "PAGE.SERVEUR-RESULTATS.TRI.dateCreation"});
    this.tries.push({code: 'DATE_PREVISIONELLE', libelle: "PAGE.SERVEUR-RESULTATS.TRI.datePrevisionnelle"});
    this.tries.push({code: 'DATE_MODIFICATION', libelle: "PAGE.SERVEUR-RESULTATS.TRI.dateModification"});

    if (this.correspondantWebServiceClient != null) {

      this.correspondantWebServiceClient.getCorrespondants().subscribe((arg) =>{
        if(arg){
          this.correspondants =arg;
        }
      },error => {
        console.log('erreur lors du chargement des correspondants');
        this.correspondants = null;
      });
    }
    this.dossierWebService.getFileProperties().subscribe(fileProperties => {
      this.fileProperties = fileProperties;
    });
  }

  refreshTable(asiTableRequest: AsiTableRequest) {
    this.currentSearchDto = {...asiTableRequest, ...this.rechercheDossierDto};
    this.rechercheDossier();
  }

  ngOnChanges(change: SimpleChange) {
    if (!change.firstChange) {
      this.articleTable.fireRefresh();
    }
  }

  exportCsv() {
    this.fileUtils.getFileAsBlobFromPostRequest(environment.contextPath + "api/dossiers/export", this.rechercheDossierDto).subscribe((fileAsBlob) => {
      this.saveToFile(fileAsBlob, "result.csv");
    });
  }

  exportFacturation() {
    this.fileUtils.getFileAsBlobFromPostRequest(environment.contextPath + "api/dossiers/exportFacturation", this.rechercheDossierDto).subscribe((fileAsBlob) => {
      this.saveToFile(fileAsBlob, "facturation.csv");
    });
  }

  sortData(code: RechercheDossierTriEnum) {
    this.currentSearchDto.tri = code;
    this.rechercheDossier();
  }

  private rechercheDossier() {
    this.showOverlay = true;
    this.showError = false;
    this.dossierWebService.rechercheDossiers(this.currentSearchDto).subscribe((resultats: PaginationResultDto) => {
      // affichage du message si les critères de recherches sont trop larges.
      this.fillComplementDossier(resultats);
      this.searchHasTooManyResults = resultats.limitExceeded;
      this.asiTableData = {...resultats.pagination, paginate: true};
      this.articleTable.updateData(this.asiTableData);
      this.showOverlay = false;
    }, error => {
      if (error.status == 422) {
        this.notificationService.showErrorNotification("PAGE.SERVEUR-RESULTATS.FILTRE.unprocessable");
      }
      if (error.status == 405  || error.status == 500) {
        this.showError = true;
      }
      this.showOverlay = false;
    });
  }

  voirDetail(ligneDossier: LigneDossierDto, event: any) {
    if (event.button === 0) {
      this.router.navigate(["cerba/detail-resultat", ligneDossier.id]);
    } else {
      window.open("/#/cerba/detail-resultat/" + ligneDossier.id);
    }
  }

  isComplementDossier(ligneDossier: LigneDossierDto) {
    return ligneDossier.complementDossierCount > 0;
  }

  complementDossier(ligneDossier: LigneDossierDto) {
    if (ligneDossier.complementDossierCount > 0) {
      let asiDialog = this.asiDialogService.fromComponent(PopinCompleterDossierComponent, null);
      asiDialog.viewContainerRef.element.nativeElement.className += " completer-dossier-dialog";

      asiDialog.getComponent().numeroDossier = ligneDossier.identifiant;
    }
  }

  planifierAlerte(dossiers: Array<LigneDossierDto>) {
    if (dossiers == null) {
      dossiers = this.getDossiersSelectionne([StatutDossierEnums.ENREGISTREE.value(), StatutDossierEnums.EN_CONTROLE.value(), StatutDossierEnums.VALIDE_PARTIEL.value()]);
    }

    let alerteDialog = this.asiDialogService.fromComponent(PlanifierAlerteModal, null);
    alerteDialog.getComponent().dossiers = dossiers;
  }

  openHprimDialog(dossiers: Array<HprimFaxMedecin>) {
    let asiDialog = this.asiDialogService.fromComponent(HprimFaxDialog, null);
    asiDialog.getComponent().dossiers = dossiers;
  }

  openHprimDialogListe() {
    let dossierRappels = new Array<HprimFaxMedecin>();

    let dossiers = this.getDossiersSelectionne([StatutDossierEnums.TERMINE.value()]);
    let identifiants = lodash.map(dossiers, (dossier) => {
      return dossier.identifiantLabo;
    });

    this.laboratoireWebService.findByIdentifiants(identifiants).subscribe((laboDtos) => {
      for (let i = 0; i < dossiers.length; i++) {
        let dossierRappel = new HprimFaxMedecin();
        dossierRappel.hprimFaxDto = new HprimFaxDto();

        dossierRappel.hprimFaxDto.numDossier = dossiers[i].identifiant;
        if (laboDtos[i] != null) {
          dossierRappel.hprimFaxDto.numCorrespondant = laboDtos[i].login;
          dossierRappel.hprimFaxDto.numFax = laboDtos[i].fax;
        }

        let idMedecin = dossiers[i].identifiantMed1;
        dossierRappel.hasMedecin = idMedecin != null && idMedecin.trim().length > 0;
        dossierRappels.push(dossierRappel);
      }

      this.openHprimDialog(dossierRappels);
    });
  }

  openHprimDialogUn(dossier: LigneDossierDto) {

    let dossierRappel = new HprimFaxMedecin();
    dossierRappel.hprimFaxDto = new HprimFaxDto();

    let identifiants = new Array<string>();
    identifiants.push(dossier.identifiantLabo);
    this.laboratoireWebService.findByIdentifiants(identifiants).subscribe((laboDtos) => {
      dossierRappel.hprimFaxDto.numDossier = dossier.identifiant;
      if (laboDtos[0] != null) {
        dossierRappel.hprimFaxDto.numCorrespondant = laboDtos[0].login;
        dossierRappel.hprimFaxDto.numFax = laboDtos[0].fax;
      }

      let idMedecin = dossier.identifiantMed1;
      dossierRappel.hasMedecin = idMedecin != null && idMedecin.trim().length > 0;
      this.openHprimDialog([dossierRappel]);
    });
  }

  openDonneesManquantesDialog(dossier: LigneDossierDto, tab: string) {
    let asiDialog = this.asiDialogService.fromComponent(DonneesManquantesComponent, null);
    asiDialog.getComponent().numeroDossier = dossier.identifiantDossier;
    asiDialog.getComponent().prenomNom = this.getDisplayIdentity(dossier.nom, dossier.prenom, dossier.nomJeuneFille);
    asiDialog.getComponent().dateDeNaissance = dossier.dateNaissance;
    asiDialog.getComponent().nom = this.getDisplayIdentity(dossier.nom, dossier.prenom, '');
    asiDialog.getComponent().prenom = dossier.prenom;
    asiDialog.getComponent().status = EtatEnums.EN_COURS;
    asiDialog.getComponent().fileProperties = this.fileProperties;

    asiDialog.onDialogClose().subscribe((shouldRefresh : boolean) => {
      if(shouldRefresh){
        this.rechercheDossiers();
      }
    });
  }

  private rechercheDossiers() {
    this.dossierWebService.rechercheDossiers(this.currentSearchDto).subscribe((resultats: PaginationResultDto) => {
      // affichage du message si les critères de recherches sont trop larges.
      this.fillComplementDossier(resultats);
      this.searchHasTooManyResults = resultats.limitExceeded;
      this.asiTableData = {...resultats.pagination, paginate: true};
      this.articleTable.updateData(this.asiTableData);
    }, error => {
      if (error.status == 422) {
        this.notificationService.showErrorNotification("PAGE.SERVEUR-RESULTATS.FILTRE.unprocessable");
      }
      if (error.status == 405  || error.status == 500) {
        this.showError = true;
      }
    });
  }

  public isHPrimEnabled(): Boolean {
    return this.hprimEnabled;
  }


  public isReemissionEnabled(): Boolean {
    return this.reemissionEnabled;
  }

  private getDossiersSelectionne(etats: Array<StatutDossierEnum>): Array<LigneDossierDto> {
    let dossiers = new Array<LigneDossierDto>();
    if (this.selectionModel.allChecked == false) {
      this.selectionModel.itemsIncluded.forEach(dossier => {
        if (lodash.indexOf(etats, dossier.statut) != -1) {
          dossiers.push(dossier);
        }
      })
    } else {
      this.asiTableData.results.forEach(dossier => {
        if (lodash.indexOf(this.selectionModel.itemsExcluded, dossier) == -1) {
          if (lodash.indexOf(etats, dossier.statut) != -1) {
            dossiers.push(dossier);
          }
        }
      });
    }
    return dossiers;
  }

  hasTermine(): boolean { //return true si la sélection contient un dossier terminé
    let dossiers = new Array<LigneDossierDto>();
    if (this.selectionModel.allChecked == false) {
      this.selectionModel.itemsIncluded.forEach(dossier => {
        if (dossier.statut == StatutDossierEnums.TERMINE.value()) {
          dossiers.push(dossier);
        }
      });
    } else {
      this.asiTableData.results.forEach(dossier => {
        if (lodash.indexOf(this.selectionModel.itemsExcluded, dossier) == -1) {
          if (dossier.statut == StatutDossierEnums.TERMINE.value()) {
            dossiers.push(dossier);
          }
        }
      });
    }
    return dossiers.length > 0;
  }

  hasOnlyComplet(): boolean {
    let dossiers = new Array<LigneDossierDto>();
    if (this.selectionModel.allChecked == false) {
      this.selectionModel.itemsIncluded.forEach(dossier => {
        if (!(dossier.statut == StatutDossierEnums.TERMINE.value() || dossier.statut == StatutDossierEnums.VALIDE_COMPLET.value())) {
          dossiers.push(dossier);
        }
      });
    } else {
      this.asiTableData.results.forEach(dossier => {
        if (lodash.indexOf(this.selectionModel.itemsExcluded, dossier) == -1) {
          dossiers.push(dossier);
        }
      });
    }
    return dossiers.length == 0;
  }

  isTermine(dossier: LigneDossierDto) {
    return dossier.statut == StatutDossierEnums.TERMINE.value();
  }

  isDossierComplet(dossier: LigneDossierDto) {
    return dossier.statut == StatutDossierEnums.TERMINE.value() ||
      dossier.statut == StatutDossierEnums.VALIDE_COMPLET.value();
  }


  getCorrespondantTags(dossier : LigneDossierDto ) : string[] {
    let tags : string[] = null;

    if(this.correspondants){
      for(let correspondant of this.correspondants){
        if( correspondant.code == dossier.identifiantLabo){
          tags = correspondant.tags;
          break;
        }
      }
    }

   return tags;
  }

  hasDonneesManquantesAndTags(dossier: LigneDossierDto) {
    try {
      let tags = this.getCorrespondantTags(dossier);
      if (tags != null) {
        let hasTags = tags.includes(TagsDonneesManquantes.FEL_CONTRIB) || tags.includes(TagsDonneesManquantes.FEL_GEST);
        return hasTags && dossier.nbDonneeManquante != null && dossier.nbDonneeManquante > 0;
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  isDossierPartiel(dossier: LigneDossierDto) {
    return dossier.statut == StatutDossierEnums.VALIDE_PARTIEL.value();
  }

  private saveToFile(fileAsBlob: Blob, fileName: string) {
    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(fileAsBlob, fileName);
    } else {
      let url = window.URL.createObjectURL(fileAsBlob);
      var anchor = document.createElement("a");
      anchor.download = fileName;
      anchor.target = '_blank';
      anchor.href = url;
      anchor.dispatchEvent(new MouseEvent("click"));
    }
  }


  getDisplayIdentity(nom: String, prenom: String, nomJF: String) {
    let identity = "";

    if (prenom != null){
      identity = prenom + " ";
    }
    if (nom != null) {
      identity += nom;
    }
    if (nomJF != null && nomJF != "") {
      identity += this.translateService.instant("PAGE.SERVEUR-RESULTATS.neeLe");
      identity += nomJF;
    }
      return identity;
  }


  private fillComplementDossier(resultats: PaginationResultDto) {
    resultats.pagination.results.forEach(r => {
      let rechercheInstanceModeleFormulaireDto: RechercheInstanceModeleFormulaireDto = new RechercheInstanceModeleFormulaireDto();
      rechercheInstanceModeleFormulaireDto.statuts = ['EN_COURS'];
      rechercheInstanceModeleFormulaireDto.numeroDossier = r.identifiant;
      // this.instanceModeleFormulaireWebServiceClient.countSearchInstanceModeleFormulaire(rechercheInstanceModeleFormulaireDto).subscribe(data => {
      //   r.complementDossierCount = data;
      // });
    });
  }

  isValueExists(value : string) {
    return value != '' && value != undefined && value;
  }

  isDateDepassee(value: string): boolean {
    const currentDate = new Date();
    const examDate = new Date(value);
    currentDate.setHours(0, 0, 0, 0);
    examDate.setHours(0, 0, 0, 0);
    if(value == null) {
      return false;
    }
    if ( examDate <  currentDate) {
      return true;
    } else {
      return false;
    }

  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/serveur-resultats/resultats/serveur-resultats-resultats.component.ts